import { render } from "./InventoryReceiving.vue?vue&type=template&id=4653c43e&scoped=true"
import script from "./InventoryReceiving.vue?vue&type=script&lang=js"
export * from "./InventoryReceiving.vue?vue&type=script&lang=js"

import "./InventoryReceiving.vue?vue&type=style&index=0&id=4653c43e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4653c43e"]])

export default __exports__